'use client';

import { useEffect } from 'react';

import { buildCopilotCartContext } from '@helpers/copilot-context';

import { cartStore } from '@stores/cart';

export function CopilotCartContext() {
    useEffect(() => {
        const updateWindowContext = () => {
            const context = buildCopilotCartContext(cartStore.getState().byouCart);

            window.cart_context = context;
        };

        updateWindowContext();

        return cartStore.subscribe(updateWindowContext);
    }, []);

    return null;
}
